import { render, staticRenderFns } from "./package-modal.vue?vue&type=template&id=43367cdb"
import script from "./package-modal.vue?vue&type=script&lang=js"
export * from "./package-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports